import { IReadOptions, AjaxHelper } from '@samc/common';
import { CachedDataSource } from '@/Sources/BaseDataSources';
import { ITaskGroupModel } from '@samc/taskmanagement-ui';
import { IResponse } from '@samc/taskmanagement-ui/dist/types/interfaces';

export class TaskGroupsSource extends CachedDataSource<ITaskGroupModel> {
  private readonly _helper: AjaxHelper;

  public constructor(
    private _apiRoot?: string,
    private _jwt: string | null = null,
    private _token: string | null = null
  ) {
    super();
    this._helper = new AjaxHelper(_apiRoot ?? '', _token ?? null, null, _jwt ?? null);
  }

  public async loadData(
    options: IReadOptions,
    abortController: AbortController
  ): Promise<ITaskGroupModel[]> {
    const data = (await this._helper.getData<IResponse<ITaskGroupModel[]>>('/taskgroup')).data;
    return data.sort((a, b) => a.name.localeCompare(b.name));
  }
}
